"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconClose = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconClose = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M20.794 18.19L14.41 12l6.384-6.19c.271-.263.271-.68 0-.922l-1.925-1.866-6.86 6.651L5.129 3 3.204 4.866c-.272.263-.272.68 0 .922l6.384 6.19-6.362 6.213c-.272.263-.272.68 0 .922l1.924 1.866 6.86-6.652L18.89 21l1.925-1.866a.667.667 0 00-.022-.943z"
}));
exports.IconClose = IconClose;
//# sourceMappingURL=IconClose.js.map